import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup, OAuthProvider, RecaptchaVerifier, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, set, get } from "firebase/database";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { useToastStore } from "store/toastStore";
import { getFirestore, doc, setDoc, addDoc, collection, getDocs, getDoc, onSnapshot, orderBy } from "firebase/firestore";
import { Timestamp } from "firebase-admin/firestore";
import firebase from 'firebase/app';
import { query, where, writeBatch } from "firebase/firestore";


interface Notification {
  id: string;
  IsRead: boolean;
  createdAt: Timestamp;
  message: string;
  requester: string;
  responder: string;
  title: string;
}




// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDWfQ7xY592EGsmIfUd2YIcNwNIh6GRAhA",
  authDomain: "standbytravel-1e2f1.firebaseapp.com",
  projectId: "standbytravel-1e2f1",
  storageBucket: "standbytravel-1e2f1.firebasestorage.app",
  messagingSenderId: "1058374584279",
  appId: "1:1058374584279:web:c95fb82009080ceca0ed92",
  measurementId: "G-SYDDT0HVT3",
  databaseURL: "https://standbytravel-1e2f1-default-rtdb.firebaseio.com/"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
// const analytics = getAnalytics(app);
const auth = getAuth(app);
const database = getDatabase(app);
const firestore = getFirestore(app);
const appleProvider = new OAuthProvider("apple.com");
const googleProvider = new GoogleAuthProvider();

// ✅ Function to Get the Current User's UID
const getUserId = (): Promise<string | null> => {
  return new Promise((resolve) => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        resolve(user.uid);
      } else {
        resolve(null);
      }
    });
  });
};

// ✅ Function to Save User Settings
const saveSettings = (userId: string, settings: object) => {
  const settingsRef = ref(database, 'users/' + userId + '/settings');

  return new Promise<void>((resolve, reject) => {
    set(settingsRef, settings)
      .then(() => {
        resolve(); // Resolve when saved successfully
      })
      .catch((error) => {
        reject(error); // Reject on error
      });
  });
};

// ✅ Function to Get User Settings
const getSettings = async (userId: string) => {
  const settingsRef = ref(database, 'users/' + userId + '/settings');
  const snapshot = await get(settingsRef);
  if (snapshot.exists()) {
    return snapshot.val();
  } else {
    return null; // No settings found
  }
};

// Function to request notification permission and get the device token
const logDeviceToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Notification permission denied");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });

    console.log("Your FCM device token is:", token);

    // Display token on screen if needed
    const displayElement = document.getElementById("token-display");
    if (displayElement) {
      displayElement.innerText = token;
    }

    // Save token to Firestore if user is authenticated
    const user = auth.currentUser;
    if (user && token) {
      const tokenRef = doc(firestore, "deviceTokens", user.uid);
      await setDoc(tokenRef, { token });
      console.log("Device token saved to Firestore");
    }

    return token;
  } catch (err) {
    console.error("Error getting or saving device token:", err);
    return null;
  }
};


// ✅ New function to handle FCM messages with toast notifications
const setupMessageHandler = () => {
  const { showToast } = useToastStore.getState(); // Get the function directly from the store

  return onMessage(messaging, (payload) => {
    console.log('Message received:', payload);

    // Extract notification data
    const title = payload.notification?.title || 'New Notification';
    const message = payload.notification?.body || '';

    // Determine notification type based on payload if available
    let type = "info";
    if (payload.data && payload.data.type) {
      if (payload.data.type === "success" || payload.data.type === "error") {
        type = payload.data.type;
      }
    }

    // Show toast notification using your Zustand store
    showToast(message, type as "success" | "error" | "info", 5000);
  });
};


export const requestPermissionAndSaveToken = async () => {
  try {
    const messaging = getMessaging();
    const token = await getToken(messaging, {
      vapidKey: "BO16_PQwa4xYENvbnBNaDXlBCJBaV0xclX4VmRgPG0fabMlmF-Qc9qpAe2f_ZdG5gP3poW526ZagqINSk9W2Je4", // replace with your actual VAPID key
    });

    if (token) {
      const user = auth.currentUser;
      if (!user) return;

      // Save using UID as document ID to avoid duplicates
      await setDoc(doc(firestore, "deviceTokens", user.uid), {
        uid: user.uid,
        token: token,
        updatedAt: new Date(),
      });

      console.log("✅ Token saved with UID as doc ID:", user.uid);
    } else {
      console.warn("⚠️ No token received, permission might be denied.");
    }
  } catch (error) {
    console.error("❌ Error getting FCM token or saving to Firestore:", error);
  }
};




const fetchUserNotifications = async (): Promise<Notification[] | null> => {
  try {
    const user = auth.currentUser;
    if (!user) {
      console.log("No user is signed in");
      return null;
    }

    const uid = user.uid;
    console.log("Fetching notifications for user:", uid);

    const notificationsCollectionRef = collection(
      firestore,
      "load_notifications",
      uid,
      "notifications"
    );

    const querySnapshot = await getDocs(notificationsCollectionRef);

    if (!querySnapshot.empty) {
      const notifications: Notification[] = querySnapshot.docs.map((doc) => {
        const data = doc.data();

        return {
          id: doc.id,
          IsRead: data.IsRead,
          createdAt: data.createdAt,
          message: data.message,
          requester: data.requester,
          responder: data.responder,
          responderName: data.responderName,
          title: data.title,
        };
      });

      console.log("Total notifications:", notifications.length);
      notifications.forEach((notification, index) => {
        console.log(`Notification ${index + 1}:`, notification);
      });

      return notifications;
    } else {
      console.log("No notifications found for this user");
      return [];
    }
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return [];
  }
};


export const updateNotificationAsRead = async (notificationId: string, userId: string) => {
  try {
    // Create the reference to the specific notification document by its ID
    const docRef = doc(firestore, 'load_notifications', userId, 'notifications', notificationId);

    // Get the document snapshot
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      console.log("No notification found with the ID:", notificationId);
      return { success: false, count: 0 };
    }

    // Prepare a batch for updating notifications
    const batch = writeBatch(firestore);

    // Update the IsRead field for the specific notification document
    batch.update(docRef, { IsRead: true });
    console.log(`Adding update for notification ID: ${notificationId}`);

    // Commit the batch update
    await batch.commit();

    console.log(`Successfully updated notification with ID: ${notificationId}`);
    return { success: true, count: 1 };
  } catch (error) {
    console.error("Error updating notification:", error);
    return { success: false, error };
  }
};

export const subscribeToUserNotifications = (
  userId: string,
  callback: (notifications: any[]) => void
) => {
  const notificationsRef = collection(firestore, "load_notifications", userId, "notifications");
  const q = query(notificationsRef, orderBy("createdAt", "desc"));

  return onSnapshot(q, (snapshot) => {
    const notifications = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    callback(notifications);
  });
};

// Export everything
export {
  app,
  // analytics,
  auth,
  database,
  GoogleAuthProvider,
  googleProvider,
  appleProvider,
  signInWithPopup,
  RecaptchaVerifier,
  getUserId,
  messaging,
  saveSettings,
  getSettings,
  logDeviceToken,
  firestore,
  setupMessageHandler, // Export the new function
  fetchUserNotifications
};